import { render, staticRenderFns } from "./IngestionResultsLogDialog.vue?vue&type=template&id=6c611607"
import script from "./IngestionResultsLogDialog.vue?vue&type=script&lang=js"
export * from "./IngestionResultsLogDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports